/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Dropdown } from "flowbite-react";
import { ChatContext } from "../contexts/ChatContext";
import { FaRegPenToSquare } from "react-icons/fa6";
import {FaTrash, FaCog, FaQuestionCircle, FaComments } from "react-icons/fa";
import { PiDotsThreeBold } from "react-icons/pi";
import { RiShare2Line } from "react-icons/ri";
import ShareChat from "../ChatButtons/ShareChat";
import { RemoveChatContext } from "../contexts/RemoveChatContext";
import { useNavigate } from "react-router-dom";

const Sidebar = ({ isOpen, toggleSidebar, setMessages, response }) => {
  const { titles, setSideId ,loadChatHistory} = useContext(ChatContext);
  const {setUserid}=useContext(RemoveChatContext)
    const user_id = localStorage.getItem("user_id");
    const sessionId = localStorage.getItem("sessionId");
  const [selectedChat, setSelectedChat] = useState(null);
  const [shareLink, setShareLink] = useState(false);

  const navigate = useNavigate();
  const handleDelete=()=>{
     UpdateChat(sessionId);
     setUserid(sessionId);
  }
  
  useEffect(() => {
    loadChatHistory(user_id);
  }, []);

  useEffect(() => {
    loadChatHistory(user_id);
  }, [response,user_id]);

   const UpdateChat = async(sessionId)=>{
    const URL=`https://gemxbackend.onrender.com/conversation/sideTitleDelete/${sessionId}`;
    try {
      const response = await axios(URL);
      if(response.data){
        loadChatHistory(user_id);
      }
    } catch (error) {
      console.error("Something went wrong")
    }
  } 

  const handleTitleClick = (sideId) => {
    
    setSideId(sideId);
    setSelectedChat(sideId);
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-white opacity-50 md:hidden"
          onClick={toggleSidebar}
        ></div>
      )}
      <aside
        className={`fixed inset-y-0 left-0 z-50 w-64 outline-double outline-custom1 dark:bg-black bg-slate-100  transform transition-transform duration-500 ease-in-out ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } md:relative md:translate-x-0`}
        style={{ display: isOpen ? "block" : "none" }}
      >
        <div className="flex flex-col h-full">
          <div className="p-4 flex justify-between items-center">
            {isOpen && (
              <>
                <button onClick={toggleSidebar} className="text-white">
                  <img
                    src="https://img.icons8.com/?size=100&id=eMQsFGlY7TA4&format=png&color=999999"
                    alt="Home"
                    className="h-8 w-8 mt-4"
                  />
                </button>
                <button
                  onClick={setMessages}
                  className="text-white flex items-center"
                >
                  <FaRegPenToSquare
                    className="mr-2 mt-4 h-6 w-6"
                    color="#999999"
                  />
                </button>
              </>
            )}
          </div>
          <div className="flex-1 overflow-y-auto custom-scrollbar">
            <div className="px-4 py-2 border-b border-gray-700 flex items-center">
              <FaComments className="mr-2" color="#999999" />
              <h2 className="text-lg font-semibold">Past conversations</h2>
            </div>
            <div className="p-4 text-white max-h-[1200px] overflow-hidden">
              <div className="text-sm md:text-base">
                {titles?.map((chat, index) => (
                  <p
                    key={index}
                    onClick={() => handleTitleClick(chat.sessionId)}
                    className={`cursor-pointer p-2 rounded ${
                      selectedChat === chat.sessionId
                        ? "bg-gray-600 text-white"
                        : "hover:bg-gray-500 hover:text-white"
                    }`}
                    style={{
                      maxWidth: "250px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    {(chat?.title).length > 20
                      ? chat?.title.substring(0, 18) + " ..."
                      : chat?.title}
                    <Dropdown
                      arrowIcon={false}
                      inline
                      label={
                        selectedChat === chat.sessionId ? (
                          <button className="text-2xl text-slate-300 hover:text-black hover:dark:text-white hover:text-3xl ">
                            <PiDotsThreeBold />
                          </button>
                        ) : (
                          ""
                        )
                      }
                    >
                      <Dropdown.Item
                        class="gap-3 w-28 flex justify-center items-center h-10"
                        onClick={() => setShareLink(true)}
                      >
                        <RiShare2Line />
                        Share
                      </Dropdown.Item>
                      <Dropdown.Divider />
                       <Dropdown.Item
                       class="gap-3 w-28 flex justify-center items-center h-10 delete" onClick={handleDelete}
                       >
                       <FaTrash/>
            Delete
          </Dropdown.Item>
          {/*
          <Dropdown.Item>
            <Button >SignOut</Button>
          </Dropdown.Item> */}
                    </Dropdown>
                  </p>
                ))}
              </div>
            </div>
          </div>
          <div className="px-4 py-2 border-t border-gray-700 mt-auto">
            <div onClick={()=>navigate('/chatSetting')} className="flex items-center py-2 cursor-pointer">
              <FaCog size={20} color="#999999" />
              <span className="ml-2">Settings</span>
            </div>
            <div onClick={()=>navigate('/help')} className="flex items-center py-2 cursor-pointer">
              <FaQuestionCircle size={20} color="#999999" />
              <span className="ml-2">Help</span>
            </div>
          </div>
        </div>
      </aside>
      {shareLink && <ShareChat onClose={() => setShareLink(false)} />}
    </>
  );
};

export default Sidebar;
